import React from "react";
import { ShieldCheck, ShieldAlert, ShieldX, Eye } from "lucide-react";
import { useLang } from "@/context/LanguageContext";

const GRADE_STYLES = {
  A: "bg-emerald-100 text-emerald-700 border-emerald-200",
  B: "bg-blue-100 text-blue-700 border-blue-200",
  C: "bg-amber-100 text-amber-700 border-amber-200",
  D: "bg-red-100 text-red-700 border-red-200",
};

export const GradeBadge = ({ grade }) => {
  const { t } = useLang();
  const g = (grade || "C").toUpperCase();
  return (
    <span className={`inline-flex items-center rounded-full border px-2.5 py-1 text-xs font-bold ${GRADE_STYLES[g] || GRADE_STYLES.C}`}>
      {t(`grade.${g}`)}
    </span>
  );
};

const WADA_MAP = {
  safe: { icon: ShieldCheck, cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  monitored: { icon: Eye, cls: "bg-blue-50 text-blue-700 border-blue-200" },
  caution: { icon: ShieldAlert, cls: "bg-amber-50 text-amber-700 border-amber-200" },
  prohibited: { icon: ShieldX, cls: "bg-red-50 text-red-700 border-red-200" },
};

export const WadaBadge = ({ status }) => {
  const { t } = useLang();
  const s = (status || "safe").toLowerCase();
  const cfg = WADA_MAP[s] || WADA_MAP.safe;
  const Icon = cfg.icon;
  return (
    <span className={`inline-flex items-center gap-1 rounded-full border px-2.5 py-1 text-xs font-semibold ${cfg.cls}`}>
      <Icon size={13} /> {t(`wada.${s}`)}
    </span>
  );
};
